import { useState, useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import ReactDOM from 'react-dom/client';
import { StepMarker } from '../step-marker'; 
import { haveStepsChanged } from 'src/utils'; 

export default function useStepMarkersLayer({
  mapRef,
  steps,
  isMapLoaded,
  lineColor,
  markersRef,
  isPublicPortal,
}) {
  const previousStepsRef = useRef();
  const [markerSize, setMarkerSize] = useState('small');

  useEffect(() => {
    if (!isMapLoaded) return;

    const stepsChanged = haveStepsChanged(steps, previousStepsRef.current);

    if (!stepsChanged && !isPublicPortal && markerSize === previousStepsRef.current?.markerSize) {
      return;
    }

    previousStepsRef.current = { steps, markerSize };

    const flatSteps = Array.isArray(steps[0]) ? steps.flat() : steps;

    // Remove old markers
    if (markersRef.current?.length) {
      markersRef.current.forEach(m => m.remove());
    }
    markersRef.current = [];

    flatSteps.forEach((step, index) => {
      const isStart = index === 0;
      const isEnd = index === flatSteps.length - 1;

      const el = document.createElement('div');
      ReactDOM.createRoot(el).render(
        <StepMarker
          key={`${step.id}-${lineColor}`}
          step={step}
          color={lineColor}
          isStart={isStart}
          isEnd={isEnd}
          size={markerSize}
        />
      );

      const marker = new mapboxgl.Marker(el)
        .setLngLat(step.point.coordinates)
        .addTo(mapRef.current);

      markersRef.current.push(marker);
    });
  }, [steps, markerSize, isMapLoaded]);

  useEffect(() => {
    if (!mapRef.current) return;

    const map = mapRef.current;

    const handleZoom = () => {
      const zoom = map.getZoom();
      //setMarkerSize(zoom < 2.5 ? 'small' : 'large');
      setMarkerSize(zoom < 4.5 ? 'small' : 'large');
    };

    map.on('zoomend', handleZoom);

    return () => {
      map.off('zoomend', handleZoom);
    };
  }, []);
}
